/**
 * Single source of truth for folder-document upload size limits on the client.
 * Must stay in sync with backend/MagiaLecha.Core/Constants/FileUploadLimits.cs
 *
 * Other upload flows (Masav, signed contracts, lead import) have their own,
 * intentionally different limits and must not use this module.
 */

export const MAX_FILE_SIZE_MB = 5;

export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const isFileSizeAllowed = (fileSize: number): boolean => fileSize <= MAX_FILE_SIZE_BYTES;

/** מחזיר הודעת שגיאה בעברית אם הקובץ חורג מהגודל המותר, אחרת null */
export const validateFileSize = (file: File): string | null =>
  isFileSizeAllowed(file.size) ? null : `גודל הקובץ חורג מהמותר (מקסימום ${MAX_FILE_SIZE_MB}MB)`;

/** Matches FileUploadLimits.MaxFilesPerBatch on the backend. */
export const MAX_FILES_PER_BATCH = 10;

/** Matches FolderDocumentService.AllowedExtensions on the backend. */
export const ALLOWED_DOCUMENT_EXTENSIONS = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.xls', '.xlsx'];

/** ערך ל-accept של input מסוג file */
export const DOCUMENT_ACCEPT = ALLOWED_DOCUMENT_EXTENSIONS.join(',');

export const isAllowedDocumentType = (fileName: string): boolean => {
  const dot = fileName.lastIndexOf('.');
  return dot >= 0 && ALLOWED_DOCUMENT_EXTENSIONS.includes(fileName.slice(dot).toLowerCase());
};
